import { Share2, MoreHorizontal, Menu, X, Smartphone } from "lucide-react";

export const PWA_STEPS = [
  {
    id: "safari-standard",
    icon: Share2,
    title: "Safari · Standard",
    steps: ["Tap the Share icon in the bottom toolbar.", "Scroll down and tap \u201cAdd to Home Screen.\u201d", "Tap \u201cAdd\u201d in the top-right corner."],
  },
  {
    id: "safari-new",
    icon: MoreHorizontal,
    title: "Safari · Newer iOS",
    steps: ["On the redesigned toolbar, tap the \u201c\u2022\u2022\u2022\u201d (More) icon.", "Tap the Share icon in the menu that opens.", "Scroll down and tap \u201cAdd to Home Screen.\u201d"],
  },
  {
    id: "chrome",
    icon: Menu,
    title: "Chrome · iOS & Android",
    steps: ["Tap the three-dot menu (\u22ee) — top-right on Android, bottom on iOS.", "Tap \u201cAdd to Home Screen\u201d or \u201cInstall App.\u201d", "Confirm to finish — Snaggedify is now one tap away."],
  },
];

// Shared "how to install" content — deliberately kept OUT of the Landing hero flow so
// above-the-fold stays focused on Hero + CTAs + the Live Deal Feed preview. Reused
// both from the Landing footer link and the in-app contextual banner (Workspace.jsx),
// which only shows up after a guest has actually engaged (never forced/blocking).
export default function PwaInstallModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div data-testid="pwa-install-modal" className="fixed inset-0 z-[200] flex items-center justify-center bg-black/60 p-4 backdrop-blur-md" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} className="relative max-h-[88vh] w-full max-w-lg overflow-y-auto rounded-3xl border border-slate-200 bg-white p-6 shadow-2xl">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-orange/10"><Smartphone className="h-5 w-5 text-brand-orange" /></div>
            <p className="text-lg font-black tracking-tight text-slate-900">Keep Snaggedify one tap away</p>
          </div>
          <button onClick={onClose} data-testid="pwa-install-modal-close" aria-label="Close" className="rounded-full p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-700">
            <X className="h-5 w-5" />
          </button>
        </div>
        <p className="mt-2 text-sm leading-relaxed text-slate-500">Add it to your home screen as a free shortcut — no App Store download required.</p>
        <div className="mt-5 grid gap-3 sm:grid-cols-3 text-left">
          {PWA_STEPS.map((p) => (
            <div key={p.id} className="rounded-2xl border border-slate-200 bg-slate-50 p-4" data-testid={`pwa-step-${p.id}`}>
              <p className="flex items-center gap-2 text-sm font-black text-slate-900"><p.icon className="h-4 w-4 text-brand-orange" /> {p.title}</p>
              <ol className="mt-2.5 space-y-1.5">
                {p.steps.map((s, i) => (
                  <li key={i} className="flex gap-1.5 text-xs leading-relaxed text-slate-500"><span className="font-black text-brand-orange">{i + 1}.</span><span>{s}</span></li>
                ))}
              </ol>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
